import { useIntl } from '@weenat/wintl'
import CopyToClipBoard from '../kit/CopyToClipBoard'
import InfoCard from '../kit/InfoCard'
import Text from '../kit/Text'

const SaveWeenatNumberTipCard = () => {
  const { t } = useIntl()

  return (
    <InfoCard
      type='tip'
      title={t('user_settings.phone_numbers.add_weenat_phone_to_contacts_alert_title')}
    >
      <Flex $gap='sm' $alignItems='center'>
        <Text>{t('user_settings.phone_numbers.add_weenat_phone_to_contacts_alert')}</Text>
        <Text $fontWeight='bold'>
          <CopyToClipBoard
            textToCopy={t('weenat.support.alert_phoneNumber')}
            actionMessageKey='weenat.support.alert_phoneNumber'
            successMessageKey='actions.copy_success'
            variant='text+icon'
          />
        </Text>
      </Flex>
    </InfoCard>
  )
}

export default SaveWeenatNumberTipCard
